// go-pim-ui router — react-router-dom 6.
//
// Routes:
//   /login                       — public OTP login
//   /                            — Companies (list); the shell wraps authed routes
//   /products                    — AllProducts (every product across companies)
//   /companies/:id               — CompanyDetail (issuer / taxation / templates)
//   /companies/:id/products      — Products (per-company catalog)
//   /documents                   — Documents (read-only lookup by payment_ref)
//   /email-templates             — EmailTemplates (per-merchant receipt/invoice email)
//   /settings                    — Settings
//   *                            — 404
//
// go-pim operators are one role tier to start — everything sits under a single
// RequireAuth (no admin/merchant split). Add role-gating later if a viewer role
// appears.
import { createBrowserRouter } from "react-router-dom";

import { App } from "@/App";
import { RequireAuth } from "@/guards/RequireAuth";
import { Login } from "@/pages/Login";
import { Companies } from "@/pages/Companies";
import { CompanyDetail } from "@/pages/CompanyDetail";
import { Products } from "@/pages/Products";
import { AllProducts } from "@/pages/AllProducts";
import { Documents } from "@/pages/Documents";
import { EmailTemplates } from "@/pages/EmailTemplates";
import { Settings } from "@/pages/Settings";
import { NotFound } from "@/pages/NotFound";

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <App />,
        children: [
          { index: true, element: <Companies /> },
          { path: "products", element: <AllProducts /> },
          { path: "companies/:id", element: <CompanyDetail /> },
          { path: "companies/:id/products", element: <Products /> },
          { path: "documents", element: <Documents /> },
          { path: "email-templates", element: <EmailTemplates /> },
          { path: "settings", element: <Settings /> },
          // 404 inside the authed shell so an operator who lands on a bad URL
          // keeps the sidebar + topbar context.
          { path: "*", element: <NotFound /> },
        ],
      },
    ],
  },
  // Unauthed users hitting an unknown URL get the standalone 404.
  { path: "*", element: <NotFound /> },
]);
